export default "__VITE_ASSET__B7ug0zVZ__"